import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../../../../environments/environment';
import { ErrorService } from '../../../error';
import { ListItem } from '../../typeahead/types';
import {
  AttendanceRegularityQueryModel,
  AttendanceRegularityModel,
  AttendanceUsersQueryModel,
} from './types';

@Injectable({
  providedIn: 'root',
})
export class UserWorkAttendanceApiService {
  constructor(
    private readonly httpClient: HttpClient,
    private readonly errorService: ErrorService,
  ) {}

  getRegularity = (
    query: AttendanceRegularityQueryModel,
  ): Observable<AttendanceRegularityModel> => {
    let url = this.formatUrl(['regularity']);
    let params = this.toQueryParams(query);
    query.userIds.forEach((id) => (params = params.append('userIds', id)));

    return this.httpClient.get<AttendanceRegularityModel>(url, { params }).pipe(
      catchError((error) => {
        throw this.errorService.serverErrorRedirect(error);
      }),
    );
  };

  getUsers = (query: AttendanceUsersQueryModel): Observable<ListItem[]> => {
    let url = this.formatUrl(['selector', 'attendanceUsers']);

    return this.httpClient
      .get<ListItem[]>(url, { params: this.toQueryParams(query) })
      .pipe(
        catchError((error) => {
          throw this.errorService.serverErrorRedirect(error);
        }),
      );
  };

  formatUrl = (parameters: string[]): string => {
    var url = environment.comparanooapiurl;
    url += environment.features.userWorkAttendance.url;
    parameters.forEach((parameters) => {
      url += '/';
      url += parameters;
    });
    return url;
  };

  /** FromQuery: each id is a repeated key (salesTeamIds=1&salesTeamIds=2); an empty list sends no key. */
  private toQueryParams(query: AttendanceUsersQueryModel): HttpParams {
    let params = new HttpParams()
      .append('from', query.from)
      .append('to', query.to)
      .append('includeFormerEmployees', query.includeFormerEmployees);
    query.salesTeamIds.forEach(
      (id) => (params = params.append('salesTeamIds', id)),
    );
    query.groupIds.forEach((id) => (params = params.append('groupIds', id)));

    return params;
  }
}
